import { render, staticRenderFns } from "./HeaderAccountButton.vue?vue&type=template&id=1c7d3a4e&scoped=true"
import script from "./HeaderAccountButton.vue?vue&type=script&lang=js"
export * from "./HeaderAccountButton.vue?vue&type=script&lang=js"
import style0 from "./HeaderAccountButton.vue?vue&type=style&index=0&id=1c7d3a4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d3a4e",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fheader-account-button%2FHeaderAccountButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports